var utils = require('../../utils')
export default {
  name: 'monthly-check',
  data () {
    var today = new Date
    return {
      shop_id: this.$store.getters.currentShopId,
      kyotaku_id: 0,
      yakureki_id: 2,
      jyutaku_id: 0,
      kashi_id: 2,
      kahou_id: 2,
      facility_all: true,
      facility_person: true,
      year: today.getFullYear(),
      month: today.getMonth() + 1
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  created: function() {
    var self = this
    var data = {}
    var ssShopID = window.sessionStorage.getItem('mc-shopID')
    var ssYear = window.sessionStorage.getItem('mc-year')
    var ssMonth = window.sessionStorage.getItem('mc-month')
    var ssKyotakuID = window.sessionStorage.getItem('mc-kyotakuID')
    var ssYakurekiID = window.sessionStorage.getItem('mc-yakurekiID')
    var ssJyutakuID = window.sessionStorage.getItem('mc-jyutakuID')
    var ssKashiID = window.sessionStorage.getItem('mc-kashiID')
    var ssKahouID = window.sessionStorage.getItem('mc-kahouID')
    var ssFacilityAll = window.sessionStorage.getItem('mc-facilityAll')
    var ssFacilityPerson = window.sessionStorage.getItem('mc-facilityPerson')
    if (!!ssShopID) {
      if (ssShopID === 'null') {
        this.shop_id = null
        data.shop_id = null
      } else {
        this.shop_id = ssShopID
        data.shop_id = ssShopID
      }
    } else {
      data.shop_id = this.shop_id
    }
    if (!!ssKyotakuID) {
      this.kyotaku_id = ssKyotakuID
      data.kyotaku_id = ssKyotakuID
    } else {
      data.kyotaku_id = this.kyotaku_id
    }
    if (!!ssYakurekiID) {
      this.yakureki_id = ssYakurekiID
      data.yakureki_id = ssYakurekiID
    } else {
      data.yakureki_id = this.yakureki_id
    }
    if (!!ssJyutakuID) {
      this.jyutaku_id = ssJyutakuID
      data.jyutaku_id = ssJyutakuID
    } else {
      data.jyutaku_id = this.jyutaku_id
    }
    if (!!ssKashiID) {
      this.kashi_id = ssKashiID
      data.kashi_id = ssKashiID
    } else {
      data.kashi_id = this.kashi_id
    }
    if (!!ssKahouID) {
      this.kahou_id = ssKahouID
      data.kahou_id = ssKahouID
    } else {
      data.kahou_id = this.kahou_id
    }
    if (!!ssYear) {
      this.year = ssYear
      data.year = ssYear
    } else {
      data.year = this.year
    }
    if (!!ssMonth) {
      this.month = ssMonth
      data.month = ssMonth
    } else {
      data.month = this.month
    }
    if (!!ssFacilityAll) {
      this.facility_all = 0
      data.facility_all = 0
    } else {
      if (this.facility_all) {
        data.facility_all = 1
      } else {
        data.facility_all = 0
      }
    }
    if (!!ssFacilityPerson) {
      this.facility_person = 0
      data.facility_person = 0
    } else {
      if (this.facility_person) {
        data.facility_person = 1
      } else {
        data.facility_person = 0
      }
    }

    this.$store.dispatch('SHOP_SEARCH', { data: { all_get: true }, 'allShopName': null, callback: () => {
      self.$store.dispatch('MONTHLY_CHECK',{ data : data })
    }})
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    loading() {
      return this.$store.getters.apiLoading
    },
    shops () {
      return this.$store.getters.shops
    },
    facilities () {
      return this.$store.getters.monthlyFacilities
    },
    total () {
      return this.$store.getters.monthlyFacilitiesTotal
    },
    csvFileName () {
      return this.$store.getters.csvFileName
    },
    years () {
      var today = new Date
      var years = []
      for (var y = 2015; y <= today.getFullYear(); y++ ) {
        years.push({'id': y, 'text': y + this.$t('ymd.year')})
      }
      return years
    },
    months () {
      var months = []
      for (var m = 1; m <= 12; m++ ) {
        months.push({'id': m, 'text': m + this.$t('ymd.month')});
      }
      return months
    },
    nextPage () {
      return this.$store.getters.monthlyCheckNextPageNumber
    },
    currentPage () {
      return this.$store.getters.monthlyCheckCurrentPage
    }
  },
  methods: {
    backToTop: function () {
      window.scrollTo(0, 0)
    },
    search: function (readMore) {
      var self = this
      var data = {}
      data.shop_id = this.shop_id
      data.kyotaku_id = this.kyotaku_id
      data.yakureki_id = this.yakureki_id
      data.jyutaku_id = this.jyutaku_id
      data.kashi_id = this.kashi_id
      data.kahou_id = this.kahou_id
      data.year = this.year
      data.month = this.month
      if (this.facility_all) {
        data.facility_all = 1
      } else {
        data.facility_all = 0
      }
      if (this.facility_person) {
        data.facility_person = 1
      } else {
        data.facility_person = 0
      }
      if (readMore) {
        data.page = this.$store.getters.monthlyCheckNextPageNumber
      }

      window.sessionStorage.setItem('mc-shopID', this.shop_id)
      window.sessionStorage.setItem('mc-year', this.year)
      window.sessionStorage.setItem('mc-month', this.month)
      if (this.kyotaku_id != 0) {
        window.sessionStorage.setItem('mc-kyotakuID', this.kyotaku_id)
      } else {
        window.sessionStorage.removeItem('mc-kyotakuID')
      }
      if (this.yakureki_id != 2) {
        window.sessionStorage.setItem('mc-yakurekiID', this.yakureki_id)
      } else {
        window.sessionStorage.removeItem('mc-yakurekiID')
      }
      if (this.jyutaku_id != 0) {
        window.sessionStorage.setItem('mc-jyutakuID', this.jyutaku_id)
      } else {
        window.sessionStorage.removeItem('mc-jyutakuID')
      }
      if (this.kashi_id != 0) {
        window.sessionStorage.setItem('mc-kashiID', this.kashi_id)
      } else {
        window.sessionStorage.removeItem('mc-kashiID')
      }
      if (this.kahou_id != 0) {
        window.sessionStorage.setItem('mc-kahouID', this.kahou_id)
      } else {
        window.sessionStorage.removeItem('mc-kahouID')
      }
      if (this.facility_all !== true) {
        window.sessionStorage.setItem('mc-facilityAll', this.facility_all)
      } else {
        window.sessionStorage.removeItem('mc-facilityAll')
      }
      if (this.facility_person !== true) {
        window.sessionStorage.setItem('mc-facilityPerson', this.facility_person)
      } else {
        window.sessionStorage.removeItem('mc-facilityPerson')
      }

      self.$store.dispatch('MONTHLY_CHECK',{ data : data })
    },
    downloadCsv: function () {
      var self = this
      var data = {}
      data.shop_id = this.shop_id
      data.kyotaku_id = this.kyotaku_id
      data.yakureki_id = this.yakureki_id
      data.jyutaku_id = this.jyutaku_id
      data.kashi_id = this.kashi_id
      data.kahou_id = this.kahou_id
      data.year = this.year
      data.month = this.month
      data.csv = 1
      if (this.facility_all) {
        data.facility_all = 1
      } else {
        data.facility_all = 0
      }
      if (this.facility_person) {
        data.facility_person = 1
      } else {
        data.facility_person = 0
      }
      var callback = function() {
        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var csv = '#,施設名・患者名,生年月日,性,クリニック名,医師名,介護支援事業所名,ケアマネ名,居宅療養管理指導日,薬歴日,在宅患者薬剤管理指導日,かかりつけ薬剤師指導日,かかりつけ薬剤師包括管理日,回\n'
        var index = 1
        self.facilities.forEach(function (obj) {
          csv += index + ","
          csv += obj.facility_name + ","
          csv += ",,,,,,,,,,,\n"
          obj.patients.forEach(function (csv_patient) {
            csv += ","
            csv += csv_patient.patient_name + ","
            csv += csv_patient.birthday + ","
            csv += csv_patient.sex + ","
            csv += csv_patient.clinic_name + ","
            csv += csv_patient.doctor_name + ","
            csv += csv_patient.careoffice_name + ","
            csv += csv_patient.careman_name + ","
            csv += csv_patient.service_date0 + ","
            csv += csv_patient.service_date1 + ","
            csv += csv_patient.service_date2 + ","
            csv += csv_patient.service_date4 + ","
            csv += csv_patient.service_date5 + ","
            csv += csv_patient.service_count
            csv += "\n"
          })
          csv += ",,,,,,,,,,,,小計: " + obj.count + "件," + obj.services_sum + "回\n"
          index += 1
        })
        var blob = new Blob([bom, csv], { type: 'text/csv' })
        var hiddenElement = document.createElement('a')
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.target = '_blank'
        hiddenElement.download = self.csvFileName
        hiddenElement.click()
      }
      self.$store.dispatch('MONTHLY_CHECK_CSV',{ data : data, callback : callback })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/monthly-check.js